import supabase from "../lib/supabase";

/**
 * Profile gate for auth: `public.users.is_active === false` means no app access.
 * RLS `users_self` still allows the row to be read so we can evaluate this after sign-in.
 */
/**
 * Code voor het geval waarin de aanvraag GEEN antwoord kreeg — geen DNS, geen
 * verbinding, of het verzoek werd afgebroken. `postgrest-js` levert dat aan als
 * `status: 0` met een LEGE code en de tekst "TypeError: Failed to fetch".
 *
 * Waarom een eigen code (15-09-2026). In Sentry stond dat geval een maand lang
 * naast echte PostgREST-fouten in één issue: de allow-list laat een lege tag
 * vallen, dus `code` ontbrak en er was niets om op te onderscheiden. Een fetch
 * die geen leesbaar antwoord kreeg is iets anders dan een server die "nee" zegt,
 * en dat verschil hoort in de melding te staan.
 */
export const NETWERK_ONBEREIKBAAR = "network_unreachable";

export async function fetchUserAppAccessAllowed(userId: string): Promise<boolean> {
  const { data, error, status } = await supabase.from("users").select("is_active").eq("id", userId).maybeSingle();
  if (error) {
    // De CODE meedragen, niet alleen de tekst: hierop onderscheidt de aanroeper een
    // dode sessie (uitloggen) van een hapering van de leverancier (sessie behouden).
    // `new Error(error.message)` gooide dat verschil weg en liet de gebruiker vastzitten.
    const zonderAntwoord = status === 0 && !error.code;
    throw Object.assign(new Error(error.message), {
      code: zonderAntwoord ? NETWERK_ONBEREIKBAAR : error.code,
      status,
      details: error.details,
    });
  }
  if (!data) {
    return true;
  }
  return data.is_active !== false;
}
